import React from 'react';

// CENEC throbber — Adwaita / GNOME 50 Gtk.Spinner emulation.
// Styling lives in App.css under `.cenec-spinner`.
//
// <CenecSpinner />                       inline 24px
// <CenecSpinner size="sm" />             16px
// <CenecSpinner size="lg" />             48px
// <CenecLoadingRow label="Loading…" />   inline spinner + label
// <CenecLoadingBlock label="Loading…" /> centered block for empty containers

export function CenecSpinner({ size = 'md', label = 'Loading' }) {
  return (
    <span className={`cenec-spinner ${size}`} role="status" aria-label={label}>
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <rect key={i} x="14.5" y="3" width="3" height="8" rx="1.5" />
        ))}
      </svg>
    </span>
  );
}

export function CenecLoadingRow({ label = 'Loading…', size = 'sm' }) {
  return (
    <span className="cenec-loading-row">
      <CenecSpinner size={size} label={label} />
      <span>{label}</span>
    </span>
  );
}

export function CenecLoadingBlock({ label = 'Loading…', size = 'lg' }) {
  return (
    <div className="cenec-loading-block">
      <CenecSpinner size={size} label={label} />
      <span>{label}</span>
    </div>
  );
}

export default CenecSpinner;
